import Box from '@mui/joy/Box';
import Alert from '@mui/joy/Alert';

export default function AlertBasic() {
  return (
    <Box sx={{ width: '100%' }}>
      <Alert>This is a basic Alert.</Alert>
    </Box>
  );
}
